module.exports = __webpack_public_path__ + "static/img/14010015.e01af3d3.png";